export default "__VITE_ASSET__e27de01f__"